import { getLoginUrl } from '../helpers/config';
import handleFetchErrors from '../helpers/handleFetchErrors';

const handle401 = (response: Response) => {
  if (response.status === 401) {
    return response.json().then((e: { status: unknown }) => {
      if (e.status) {
        throw e;
      }
      throw { ...e, status: response.status };
    });
  }
  return response;
};

export type Token = {
  accessToken: string;
  expiresAt: string;
};

const getReferrerUrl: () => string = () => {
  let urlParams = '';
  const location = window.location;
  let { href: currentUrl } = location;
  const { search } = location;
  const searchParams = new URLSearchParams(search);

  if (!searchParams.has('referrer_url') && document.referrer) {
    searchParams.append('referrer_url', document.referrer);
    urlParams = '?' + searchParams.toString();
    currentUrl = search
      ? currentUrl.replace(search, urlParams)
      : currentUrl + urlParams;
  }

  return currentUrl;
};

export const fetchToken: () => Promise<Token> = () => {
  const currentUrl = getReferrerUrl();

  const url = `${getLoginUrl()}/api/v1/authentication/refresh?currentUrl=${encodeURIComponent(
    currentUrl,
  )}`;
  return fetch(url, { credentials: 'include' })
    .then(handle401)
    .then(handleFetchErrors)
    .then((res) => res.json());
};
